import { IFavoritesFolder } from '../../types/favoriteEntity';
import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum ELkTypesActionTypes {
  Set = 'LK_TYPE :: SET',
}

export interface IAddActionPayload {
  lkType: string;
}

export interface ISelectActionPayload {
  folder: IFavoritesFolder | null;
}

export interface ISetCanLoadMoreActionPayload {
  value: boolean;
}

export type TLkTypeActions = ITypedReduxAction<ELkTypesActionTypes.Set, IAddActionPayload>;

export const setLkType: (payload: IAddActionPayload) => TLkTypeActions = actionGenerator<
  ELkTypesActionTypes.Set,
  IAddActionPayload
>(ELkTypesActionTypes.Set);
